<template>
  <div :class="$style['pt-all-order-list']">
    <pt-page-title :title="title" isSearch @search="search" @emptySearch="emptySearch" :searchKey="searchKey" @searchNo="searchNo" isParams>
      <el-button slot="before-left" type="primary" @click="goCreated">创建订单</el-button>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <el-button type="primary" @click="exportAllOrder" :loading="exportLoading">导出</el-button>
        <el-button type="primary" @click="exportHistoryAllOrder">导出历史</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
    <order-table :query-params="queryParams" :page-size="pageSize" ref="table" class="goods-all-order-table" :isFromRouter="isFromRouter">
      <template>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
            <el-button type="text" v-if="needRefund(scope.row)" @click="refund(scope.row)">退款</el-button>
            <el-button type="text" v-if="needShiping(scope.row)" @click="sendGoods(scope.row)">发货</el-button>
          </template>
        </el-table-column>
      </template>
    </order-table>
    <el-dialog :visible="is_dialog" :title="dialog_title" @close="closeDialog" :class="$style['sampling-message-dialog']">
      <sampling-message :isList="true" @getOrderList="getOrderList" :order-id="send_id" @close="closeDialog" :formVlue="formVlue" :orderDetail="orderDetail">
      </sampling-message>
    </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { allOrderLabels } from '../goods-order-options.js'
import { emptyObject } from '@/utils/lifebankUtils'
import orderTable from '../pt-order-table/withData.vue'
import samplingMessage from '../pt-order-detail/sampling-message'
import { hasPermissions } from 'utils/permissions'
const prefixCls = 'pt-all-order-list'
// 操作订单权限
const PERM_MALLSALES_ORDER_MANAGEMENT = 'PERM_MALLSALES_ORDER_MANAGEMENT'
export default {
  name: 'pt-all-order-list',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_send
      },
      set: function (val) {
        this.is_send = val
      }
    },
    tableData () {
      return this.$refs.table.tableData
    },
    // 操作订单权限
    HAS_ORDER_MANAGEMENT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_ORDER_MANAGEMENT)
    },
    layoutName () {
      return this.$route.name
    },
    title () {
      let title
      switch (this.layoutName) {
        case 'renew-deposit-order':
          title = '续存订单'
          break
        case 'immune_storage-order':
          title = '免疫细胞存储订单'
          break
        default:
          title = '全部订单'
          break
      }
      return title
    }
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    exportLoading: {
      type: Boolean,
      default: false
    },
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsTypeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    vendorsOrganizations: {
      type: Array,
      default: function () {
        return []
      }
    },
    operationalPromotions: {
      type: Array
    },
    orderOrganization: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    orderTable,
    samplingMessage
  },
  data () {
    return {
      filterLabels: allOrderLabels,
      params: {},
      queryParams: {},
      is_send: false,
      dialog_title: '',
      send_id: '',
      formVlue: {},
      orderDetail: {},
      searchKey: null,
      isFromRouter: false
    }
  },
  watch: {
    operationalPromotions: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'promotionEventObjectId') {
            item.options = val
          }
        })
      }
    },
    '$route.name': {
      handler: function (val) {
        /* 免疫细胞和续存订单列表隐藏一些筛选条件 */
        if (val === 'renew-deposit-order' || val === 'immune_storage-order') {
          this.filterLabels = allOrderLabels.filter(item => {
            if (item.value === 'goodsBelong' || item.value === 'promotionEventObjectId' || item.value === 'goodsGroupName' || item.value === 'goodsType' || item.value === 'type' ||
						item.value === 'organizationName' || item.value === 'goodsSharingOrder' || item.value === 'businessSource' || item.value === 'sharerIdentity' || item.value === 'placeUserIdentity') {
              return false
            } else {
              return true
            }
          })
        } else {
          this.filterLabels = allOrderLabels
        }
        console.log('this.filterLabelsthis.filterLabels=', this.filterLabels)
      },
      immediate: true
    },
    groupList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'goodsGroupName') {
            item.options = val
          }
        })
      },
      deep: true
    },
    goodsTypeList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'goodsType') {
            this.$set(item, 'options', val)
          }
        })
      },
      deep: true
    },
    vendorsOrganizations: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'organizationName') {
            this.$set(item, 'options', val)
          }
        })
      }
    },
    orderOrganization: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'orderOrganizationId') {
            this.$set(item, 'options', val)
          }
        })
      },
      deep: true
    }
  },
  methods: {
    searchNo (val) {
      this.searchKey = val
    },
    exportHistoryAllOrder () {
      let name
      switch (this.layoutName) {
        case 'renew-deposit-order':
          name = 'renew_deposit_order_export'
          break
        case 'immune_storage-order':
          name = 'immune_storage_order_export'
          break
        default:
          name = 'mall_order_export'
          break
      }
      this.$router.push(`/export-history/order?name=${name}`)
    },
    search (val) {
      this.searchKey = val
      //   emptyObject(this.queryParams)
      //   emptyObject(this.params)
      this.isFromRouter = false
      this.queryParams = { ...this.queryParams, searchKey: val }
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.queryParams, 'searchKey')
    },
    // 列表是否需要发货按钮
    needShiping (row) {
      return row.orderStatus === 'PAID' && row.requirements && row.requirements.requireShipping &&
      !(row.refundmentDetails && row.refundmentDetails.apply) && this.HAS_ORDER_MANAGEMENT
    },
    // 是否需要退款按钮
    needRefund (row) {
      let isBalanceWaitingPayment = row.orderStatus === 'WAITING_FOR_PAYMENT' && row.isBalanceWaitingPayment
      return (row.orderStatus !== 'WAITING_FOR_PAYMENT' || isBalanceWaitingPayment) && row.orderStatus !== 'CLOSED' &&
      !(row.refundmentDetails && row.refundmentDetails.apply) && row.type !== 'CONTRACT' && this.HAS_ORDER_MANAGEMENT
    },
    exportAllOrder () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info' }).then(_ => {
          for (var key in this.params) {
            if (!this.params[key]) {
              this.$delete(this.params, key)
            }
            if (key === 'createdtime') {
              this.$delete(this.params[key], 'index')
              this.params = { ...this.params, ...this.params[key] }
              this.$delete(this.params, key)
            }
          }
          this.queryParams = { ...this.params, searchKey: this.searchKey }
          if (this.params.goodsSharingOrder) {
            this.queryParams.goodsSharingOrder = this.params.goodsSharingOrder === 'true'
          }
          if (this.layoutName === 'renew-deposit-order') {
            this.queryParams.goodsId = '62284056f9c5b70001a6d550'
          } else if (this.layoutName === 'immune_storage-order') {
            this.queryParams.goodsId = '624ebcfe36422c0001fa5083'
          }
          // this.queryParams.orderStatus = this.queryParams.order_status === 'WAITING_FOR_PAYMENT_BALANCE' ? 'WAITING_FOR_PAYMENT' : this.queryParams.order_status
          // this.queryParams.isBalanceWaitingPayment = (this.queryParams.order_status === 'WAITING_FOR_PAYMENT' || this.queryParams.order_status === 'WAITING_FOR_PAYMENT_BALANCE')
          //   ? this.queryParams.order_status === 'WAITING_FOR_PAYMENT_BALANCE' : null
          // this.queryParams.order_status && this.$delete(this.queryParams, 'order_status')
          // this.params.searchKey = this.searchKey ? this.searchKey : null
          this.$emit('exportAllOrder', this.queryParams)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter()
    },
    getOrderList () {
      this.$refs.table.getOrderList(0)
      this.is_send = false
    },
    closeDialog () {
      this.formVlue = {}
      this.is_send = false
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      if (!isFromRouter) {
        // this.searchKey = null
        // if (this.params.searchKey) {
        //   this.$delete(this.params, 'searchKey')
        // }
      }
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'createdtime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
      this.queryParams = { ...this.params, searchKey: this.searchKey }
      if (this.params.goodsSharingOrder) {
        this.queryParams.goodsSharingOrder = this.params.goodsSharingOrder === 'true'
      }
      // this.queryParams.orderStatus = this.queryParams.order_status === 'WAITING_FOR_PAYMENT_BALANCE' ? 'WAITING_FOR_PAYMENT' : this.queryParams.order_status
      // this.queryParams.isBalanceWaitingPayment = (this.queryParams.order_status === 'WAITING_FOR_PAYMENT' || this.queryParams.order_status === 'WAITING_FOR_PAYMENT_BALANCE')
      //   ? this.queryParams.order_status === 'WAITING_FOR_PAYMENT_BALANCE' : null
      // if (this.queryParams.orderStatus === 'isDepositPaid' || this.queryParams.orderStatus === 'isBalancePaid' || this.queryParams.orderStatus === 'isAllPaid') {
      //   this.queryParams[this.queryParams.orderStatus] = true
      //   this.$delete(this.queryParams, 'orderStatus')
      // }
      // this.$delete(this.queryParams, 'order_status')
    //   JSON.parse(JSON.stringify(this.params))
    },
    goDetail (val) {
      this.$router.push('/mall-order-all/order-detail/' + val.id + '/detail')
    },
    refund (val) {
      this.$router.push('/mall-order-all/order-detail/' + val.id + '/refund')
    },
    goCreated (val) {
      this.$router.push('/order-form')
    },
    sendGoods (val) {
      this.is_send = true
      this.orderDetail = val
      this.dialog_title = '订单发货'
      this.send_id = val.id
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-all-order-list{
    :global
    .el-dialog{
        width: 50%;
        min-width: 500PX;
        max-width: 600PX;
    }
    :global
    .goods-all-order-table{
        .el-button{
        margin-right: 10px;
        +.el-button{
            margin-left: 0!important
        }
    }
    }
    .el-button{
        margin-right: 30px;
        +.el-button{
            margin-left: 0!important
        }
    }
}
.sampling-message-dialog{
    :global
    .el-dialog{
        min-width: 700Px;
        max-width: 800PX
    }
}
</style>
